module.exports = __webpack_public_path__ + "static/section2-d270d2fe9abcc6b3a8cf63afa679f446.png";